import React, {FC, useRef, useEffect} from 'react'

import Form from '@/components/Form'
import { Button } from '@/components/UiElements'
import { startNotif, closeNotif } from '@/components/DynamicForm/util/notifier'
import saveLaserProfile from '@/services/ProductService/saveLaserProfile'
import mapFormDataToApiProfile from '@/components/LaserProfile/saveData/mapFormDataToApiProfile'

import laserProfileFormItems from '@/components/LaserProfile/forms/laserProfileFormItems'
import Splash from '@/components/splash/Splash'



interface LaserProfileFormProps {
	profile: any | null
	onUpdateSuccess: () => void
	onCancel?: () => void
}




const LaserProfileForm: FC<LaserProfileFormProps> = ({ profile, onUpdateSuccess, onCancel }) => {

	const formRef = useRef<any>(null)
	const [loading, setLoading] = React.useState<boolean>(false)

	const handleSaveProfile = async ()=> {


		setLoading(true)
		const notifId = startNotif("Saving laser profile...")
		const data = formRef.current?.getData()
		const mappedData = mapFormDataToApiProfile(data)
		const updatedProfile = await saveLaserProfile(mappedData)

		console.log(updatedProfile)
		if (updatedProfile.id) {
			closeNotif(notifId, "Laser profile saved successfully", "success")
			onUpdateSuccess()
		} else {
			closeNotif(notifId, "Failed to save laser profile", {"type": "error"})
		}
		setLoading(false)
	}



	useEffect(() => {
		formRef.current.setData(profile || {})
		console.log(profile, "profile in form")
	}, [profile])

	return (
		<div className={'flex flex-col gap-xxxl'}>
			{loading && <Splash/>}
			<div className={'w-[850px] grid grid-cols-12 gap-md'}>
				<Form
					ref={formRef}
					items={laserProfileFormItems}
					defaultValues={profile || {}}

				/>
			</div>
			<div className={'flex justify-end gap-md'}>
				{onCancel && (
					<Button
						size="lg"
						type="alt"
						onClick={onCancel}
						disabled={loading}
					>
						Cancel
					</Button>
				)}
				<Button
					size="lg"
					onClick={handleSaveProfile}
					disabled={loading}
				>
					{profile ? profile.id === "duplicate" ? 'Add Laser Profile' : 'Update Laser Profile' : 'Add Laser Profile'}
				</Button>
			</div>
		</div>
	)
}


export default LaserProfileForm
